import React, { useState } from 'react';

/**
 * Se receber o propSetValue, vai retornar [propValue, propSetValue]. Senão,
 * vai funcionar como se fosse um useState.
 * @param propValue
 * @param propSetValue
 * @param initialState
 * @returns
 */
const useLocalOrPropState = function <S>(propValue: S, propSetValue: React.Dispatch<React.SetStateAction<S>>, initialState?: S | (() => S)): [S | undefined, React.Dispatch<React.SetStateAction<S | undefined>>] {
  const [localValue, setLocalValue] = useState<S>(() => {
    if (initialState !== undefined) {
      if (typeof initialState == 'function') return (initialState as () => S)();else return initialState;
    } else if (propSetValue) {
      return propValue;
    }
    return undefined;
  });
  const s = propSetValue ? propValue : localValue;
  const setS = propSetValue ? propSetValue : setLocalValue;
  return [s, setS];
};
export default useLocalOrPropState;